import { useState } from "react";
import instance from "../Interceptor/api_instance";
import { useToast } from "../Components/ui/toast/toast";
import { useTranslation } from "react-i18next";

export function useMutate<TRequest, TResponse = TRequest>(
  url: string,
  method: "POST" | "PUT" | "PATCH" | "DELETE",
) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string>("");
  const [data, setData] = useState<TResponse | null>(null);
  const [statusCode, setStatusCode] = useState<number | null>(null);
  const { showToast } = useToast();

  const mutate = async (data: TRequest, messageKey?: string) => {
    setIsLoading(true);
    setError("");
    setStatusCode(null);
    setData(null);

    try {
      const response = await instance.request({
        url,
        method,
        data,
      });
      setData(response.data as TResponse);
      setStatusCode(response.status);
      if (response.status >= 200 && response.status < 300) {
        showToast(
          messageKey
            ? t(`notifications:successMessages.${messageKey}`)
            : t("notifications:successMessages.general"),
          { type: "success" },
        );
      }
      return response;
    } catch (err: any) {
      setError(err as string);
      showToast(
        messageKey
          ? t(`notifications:errorMessages.${messageKey}`)
          : (err as string),
        { type: "error", duration: 5000 },
      );
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return { mutate, isLoading, error, data, statusCode };
}
